import React from "react";
import { format, differenceInYears, parse } from "date-fns";
import { specialIdentifiers as identifiers } from "@/configs/configs";
import QueryBuilderIcon from "@mui/icons-material/QueryBuilder";
import BuildIcon from "@mui/icons-material/Build";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import FolderOpenIcon from "@mui/icons-material/FolderOpen";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
export const GENDERMAPPING: Record<number, string> = {
  1: "Male",
  2: "Female",
  3: "Male",
  4: "Female",
  5: "Male",
  6: "Female",
  7: "Male",
  8: "Female"
};
export const GENDERMAPPING_ROMANIAN: Record<number, string> = {
  1: "Masculin",
  2: "Feminin",
  3: "Masculin",
  4: "Feminin",
  5: "Masculin",
  6: "Feminin",
  7: "Masculin",
  8: "Feminin"
};
export const statusMaping: Record<string, {
  title: string;
  icon: JSX.Element;
  color: string;
}> = {
  Unregistered: {
    title: "Depusă",
    icon: <QueryBuilderIcon />,
    color: "grey"
  },
  Registered: {
    title: "Înregistrată",
    icon: <FolderOpenIcon />,
    color: "#478cff"
  },
  Processing: {
    title: "În lucru",
    icon: <BuildIcon />,
    color: "orange"
  },
  Finished: {
    title: "Finalizată",
    icon: <CheckCircleOutlineIcon />,
    color: "green"
  },
  Rejected: {
    title: "Respinsa",
    icon: <HighlightOffIcon />,
    color: "#ec2c22"
  }
};
export const userTypeMaping: Record<string, string> = {
  Citizen: "Cetățean",
  Mayor: "Primar",
  Director: "Director Compartiment",
  Operator: "Operator",
  Administrator: "Administrator"
};
export const extractBirthDate = (cnp: string, monthFirst: boolean): string => {
  if (monthFirst) {
    return `19${cnp.substring(1, 3)}-${cnp.substring(3, 5)}-${cnp.substring(5, 7)}`;
  }
  return `19${cnp.substring(1, 3)}-${cnp.substring(5, 7)}-${cnp.substring(3, 5)}`;
};
export const calculateAge = (cnp: string): number => {
  const birthday = extractBirthDate(cnp, false);
  const ageDate = differenceInYears(new Date(), parse(birthday, "yyyy-MM-dd", new Date()));
  return Math.abs(ageDate);
};
export const formatDate = (date: Date | string, dateFormat: string = "dd-MM-yyyy"): string => {
  return format(typeof date === "string" ? parse(date, "yyyy-MM-dd", new Date()) : date, dateFormat);
};
export const renderAdressString = (homeAddress: {
  street: string;
  streetNumber: string;
  building?: string;
  entrance?: string;
  floor?: string;
  apartment?: string;
}): string => {
  return "Str. " + homeAddress.street + " Nr. " + homeAddress.streetNumber + (homeAddress.building ? ` Bl. ${homeAddress.building} ` : "") + (homeAddress.entrance ? ` Sc. ${homeAddress.entrance} ` : "") + (homeAddress.floor ? ` Et. ${homeAddress.floor} ` : "") + (homeAddress.apartment ? ` Ap. ${homeAddress.apartment} ` : "");
};
export const replaceMarkers = (text: string, values: Record<string, string | undefined>): string => {
  const regex = /\<\!([a-zA-Z]+)\!\>/g;
  const foundTokens = text.match(regex);
  if (!foundTokens) {
    return text;
  }
  return foundTokens.reduce((preparedText, token) => {
    const key = token.replace("<!", "").replace("!>", "");
    if (values[key] !== undefined) {
      return preparedText.replace(token, values[key]!);
    }
    return preparedText;
  }, text);
};
export const buildReporterInfo = (createdBy: {
  displayName?: string;
  email?: string;
  phoneNumber?: string;
  profilePictureUrl?: string | null;
}, textEntries: Record<string, {
  identifier: string;
  value: string;
}>): {
  displayName: string;
  email: string;
  phoneNumber: string;
  profilePictureUrl: string | null;
} | undefined => {
  if (!textEntries) return;
  return {
    displayName: createdBy.displayName || (textEntries[Object.keys(textEntries).find(id => textEntries[id]?.identifier === identifiers.InputIDFirstNameIdentifier) || ""] || {
      value: ""
    }).value + (textEntries[Object.keys(textEntries).find(id => textEntries[id]?.identifier === identifiers.InputIDLastNameIdentifier) || ""] || {
      value: ""
    }).value || "Cetățean anonim",
    email: createdBy.email || (textEntries[Object.keys(textEntries).find(id => textEntries[id]?.identifier === identifiers.InputContactEmailIdentifier) || ""] || {
      value: ""
    }).value || "-",
    phoneNumber: createdBy.phoneNumber || (textEntries[Object.keys(textEntries).find(id => textEntries[id]?.identifier === identifiers.InputContactPhoneIdentifier) || ""] || {
      value: ""
    }).value || "-",
    profilePictureUrl: createdBy.profilePictureUrl || null
  };
};
export const buildIdentifier = (text: string): string => {
  const result = text;
  if (!result) {
    return "";
  } else {
    return result.normalize("NFKD").replace(/[^\w-]/g, "").replace(/[^a-zA-Z]/g, " ").split(" ").map(word => word.charAt(0).toUpperCase() + word.slice(1)).join("");
  }
};
export const trimString = (text: string, length: number): string => {
  if (text.length > length) {
    return text.substring(0, length) + "...";
  }
  return text;
};